import _ from 'lodash';

/**
 * @description
 * key   -> value の アッパーケース -> TEST_EVENT
 * value -> key   の スネークケース -> test_event
 * ※ key と value は同じ文字列
 */
export const EventType = {
  LOGIN: 'login', // TODO: 使ってないので削除してほしい
  LOGIN_ERROR: 'login_error', // TODO: 使ってないので削除してほしい
  TABLE_LIST_OPEN: 'table_list_open', // tableの開閉イベント // TODO: 使ってないので削除してほしい
  CURRENT_FIELD: 'current_field', // 現場情報GET完了イベント
  SELECT_FIELD: 'select_field', // 現場選択
  LAYOUT_UPDATE: 'layout_update', // レイアウトURL変更イベント
  DROPDOWN_MENU: 'dropdown_menu', // ドロップダウンイベント
  FORM_ELEMENT: 'FORM_ELEMENT', // フォームのイベント表示 // TODO: 使ってないので削除してほしい
  FIELD_FORM_EVENT: 'field_form_event', // fieldのフォームのonChangeイベント // TODO: 使ってないので削除してほしい
  USER_FORM_EVENT: 'user_form_event', // userのフォームのonChangeベント // TODO: 使ってないので削除してほしい
  CONFERENCE_MODE: 'conference_mode', //会議モード
  FULL_SCREAN_MODE: 'full_screan_mode', //フルスクリーンモード(現場配置計画用)
  HIDE_MASTER_MENU: 'hide_master_menu', //マスターメニューを閉じる
  REFRESH_PROFILE: 'refresh_profile', // 右上の更新,
  SHOW_SWITCH_USER_INTEGRATE: 'show_switch_user_integrate',
  SHOW_SWITCH_COMPANY: 'show_switch_company',
  FETCH_CCUS_INFO: 'fetch_ccus_info',
  FETCH_CONSISTENCY_STATUS: 'fetch_consistency_status',
  REFRESH_UNAPPROVED_WORKS_COUNT: 'refresh_unapproved_works_count',
  UPDATE_UNAPPROVED_WORKS_COUNT: 'update_unapproved_works_count',
  LOAD_PAGE_FUNC_NAVI: 'load_page_func_navi',
  RESET_FILTER_UNAPPROVED_WORK_PAGE: 'reset_filter_unapproved_work_page',
  ACCESS_UNAPPROVED_WORK_PAGE: 'access_unapproved_work_page',
  LAYOUT_LOADING: 'layout_loading', //現場配置計画のページロード
  ACCESS_KY_REPORT_WORK_PAGE: 'access_ky_report_work_page',
};

/**
 * イベント管理クラスすべてのイベントを管理する
 * シングルトンクラス
 */
class EventManager {
  constructor() {
    this.EventCallbacks = {};

    for (let key in EventType) {
      this.EventCallbacks[EventType[key]] = [];
    }
  }

  /**
   * @description イベントの一覧を返す。
   * @returns {String[]}
   */
  getEventTypes() {
    return _.map(Object.keys(EventType), v => v.toLowerCase());
  }

  /**
   * @description 引数の値がイベント登録されているか判定
   * @param {String} event_type
   */
  hasEventTypes(event_type) {
    if (_.isString(event_type)) {
      event_type = event_type.toUpperCase(); // 小文字でも可
      if (_.has(EventType, event_type)) {
        return EventType[event_type];
      }
    }

    return false;
  }

  /**
   * @description イベントを動的に設定
   * @param {String} event_type
   */
  registerEvent(event_type) {
    if (_.isString(event_type)) {
      const key = event_type.toLowerCase();

      // イベント登録
      EventType[event_type.toUpperCase()] = key;
      this.EventCallbacks[key] = [];
    } else {
      throw new Error(
        '引数が文字列ではありません。文字列を引数に指定してください。'
      );
    }
  }

  /**
   * @description イベントを動的に削除
   * @param {String} event_type
   */
  deleteEvent(event_type) {
    let key = this.hasEventTypes(event_type);

    if (key) {
      this.clearEventListener(key);
      delete EventType[key];
    } else {
      throw new Error(
        `指定されたイベントがありません。指定されたイベント : ${event_type}`
      );
    }
  }

  /**
   * @description 指定したイベントにコールバックを指定
   * @param {String} event_type
   * @param {Function} callback
   */
  addEventListener(event_type, callback) {
    let key = this.hasEventTypes(event_type);

    if (key) {
      return this.EventCallbacks[key].push(callback);
    }

    throw new Error(
      `指定されたイベントがありませんでした。指定されたイベント : ${event_type}`
    );
  }

  /**
   * @description 指定したイベントのコールバックを削除
   * @param {String} event_type
   * @param {Function} callback
   */
  removeEventListener(event_type, callback) {
    let key = this.hasEventTypes(event_type);

    if (key) {
      let event_cbs = this.EventCallbacks[key]; //コールバック配列を取得

      if (_.isFunction(callback)) {
        let index = event_cbs.indexOf(callback);
        if (index !== -1) {
          return event_cbs.splice(index, 1);
        } // コールバック削除
      }
    }

    throw new Error(
      `指定されたイベントもしくはコールバックがありませんでした。指定されたイベント : ${event_type}`
    );
  }

  /**
   * @description 指定したイベントのコールバックをすべて削除
   * @param {String}
   */
  clearEventListener(event_type) {
    let key = this.hasEventTypes(event_type);

    if (key) {
      // 空の配列にする
      this.EventCallbacks[key] = [];
      this.EventCallbacks[`${key}_error`] = [];

      return true;
    } else {
      return false;
    }
  }

  /**
   * @description イベントを発火
   * @param {String} event_type
   * @param  {...any} args
   */
  trigger(event_type, ...args) {
    let key = this.hasEventTypes(event_type);

    if (key) {
      _.each(this.EventCallbacks[key], callback => {
        callback(...args); // コールバックを実行
      });

      return true;
    }

    console.warn(
      `指定されたイベントがありませんでした。指定されたイベント : ${event_type}`
    );
  }
}

const EventMg = new EventManager();

export default EventMg;

/**
 * @description Local専用のEventManager
 */
class LocalEventManager extends EventManager {
  constructor(events) {
    super();

    this.store = null;

    this.Events = {};

    this.EventCallbacks = {};

    for (let key in events) {
      this.EventCallbacks[events[key]] = [];
      this.Events[key] = events[key];
    }
  }

  /**
   * @description イベントを動的に設定
   * @param {String} event_type
   */
  registerEvent(event_type) {
    if (_.isString(event_type)) {
      // イベント登録
      const key = event_type.toLowerCase();

      this.Events[event_type.toUpperCase()] = key;
      this.EventCallbacks[key] = this.EventCallbacks[key] || [];
    } else {
      throw new Error(
        '引数が文字列ではありません。文字列を引数に指定してください。'
      );
    }
  }

  /**
   * @description イベントを動的に削除
   * @param {String} event_type
   */
  deleteEvent(event_type) {
    let key = this.hasEventTypes(event_type);

    if (key) {
      this.clearEventListener(key);
      delete this.Events[key];
    } else {
      throw new Error(
        `指定されたイベントがありません。指定されたイベント : ${event_type}`
      );
    }
  }

  /**
   * @description 引数の値がイベント登録されているか判定
   * @param {String} event_type
   */
  hasEventTypes(event_type) {
    if (_.isString(event_type)) {
      event_type = event_type.toUpperCase(); // 小文字でも可
      if (_.has(this.Events, event_type)) {
        return this.Events[event_type];
      }
    }

    return false;
  }

  setStore(data) {
    this.store = _.cloneDeep(data);
  }

  getStore() {
    return _.cloneDeep(this.store);
  }
}

/**
 * @description Local EventManager を作成する
 * @param { Object } event
 */
export function createLocalEventManager(event) {
  if (_.isObject(event)) {
    return new LocalEventManager(event);
  }

  throw new Error('引数は必ず Object型 でなければなりません。');
}



// WEBPACK FOOTER //
// ./src/utilities/EventManager.js